module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAsCAMAAABWi7jCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF2evj0eXc6+vrydLN8/Pz/Pz8ytfQ29zc1NXVzNzU6PLr4+Tk9vj20dHR////3u7pUzOYIAAAAPtJREFUeNps08EWhCAIBVCQTNOI///bQRsTLBYt7nnnaWZwrROLPsDbKYC4cBEEEbHcYnIPDC4CIGMwdi5PbKTPxvIaKC394a0bX4yN4ZvlkzPBV3fitRyTcuBj4Z0jXJH3F2+6ZKalmTrXhZH5VN6WNYnbklqOPpxjP9iEfsF0n3c9PjmQ5/BnV75rdefNvSeFa7A5LaA4PjGbuJ7T4GTix+Rg4vvkk2fcpLXl2SPWydpCYu7an2OeccN2UTR85efTtSv4cDBbt9c+z/JouPZywIOKZT2vYydi5sv9O7rHezbHdXBwHAZnx5FN3PyXvTynsEXH9ZY+PwEGANaXL+nAWBRvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/VT.png
// module id = uJ+x
// module chunks = 1